import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

// Hand-written until the OpenAPI types are regenerated.
export type ContractExtendBody = {
  end_date: string
  notify: boolean
}

export function useExtendContract() {
  const queryClient = useQueryClient()
  const toast = useToast()
  const { t } = useTranslation('toast')
  const onError = useOnError()

  async function extendContract({
    id,
    body
  }: {
    id: string
    body: ContractExtendBody
  }) {
    const res = await apiClient.post(
      `${SNA_PREFIX}contracts/${id}/extend`,
      body,
      { params: { type: 'offer' } }
    )
    return res.data
  }

  return useMutation({
    mutationFn: extendContract,
    onSuccess: () => {
      toast.success({ message: t('contractExtended') })
      queryClient.invalidateQueries({ queryKey: ['contracts'] })
      queryClient.invalidateQueries({ queryKey: ['offers'] })
      queryClient.invalidateQueries({ queryKey: ['offers-detail'] })
    },
    onError
  })
}
